import styled, {css} from 'styled-components';
import { Box, Text } from '@bechtel/gds';

export const mapHeight = '265px';

export const MapContainerStyled = styled(Box).attrs({ mb: { sm: '500' } })`
  height: ${mapHeight};
`;

export const LocationDescStyled = styled(Box).attrs({
  p: { sm: '500' },
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
})`
  background-color: ${({ theme }) => theme.colors.grey[100]};
`;

export const FieldError = styled(Text)`
  ${({ theme }) => css`
    color: ${theme.colors.bechtel.red};
  `}
`;
